import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VImg, {
    staticClass:
      "position-absolute d-inline-flex cursor-pointer soft-version-icon-img",
    attrs: {
      contain: "",
      width: "28",
      height: "33",
      src: _vm.image.src,
      alt: _vm.image.alt,
    },
    on: {
      click: function ($event) {
        return _vm.$emit("click", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }